import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import axios from 'axios';

function Page4SubPageA2() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/followingReviews')
      .then((res) => {
        setReviews(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch reviews", err);
      })
      .finally(() => setLoading(false));
  }, []);

  const toggleVote = async (reviewId) => {
    try {
      const res = await axios.post(`/post/${reviewId}/upvote`);
      setReviews(prev =>
        prev.map(review =>
          review._id === reviewId
            ? { ...review, upvotes: res.data.upvotes, voted: res.data.voted }
            : review
        )
      );
    } catch (err) {
      console.error("Vote error", err);
    }
  };

  if (loading) {
    return <Typography>Loading reviews...</Typography>;
  }

  if (!reviews.length) {
    return <Typography>No reviews from authors you follow.</Typography>;
  }

  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom>
        Reviews from Authors You Follow
      </Typography>

      {reviews.map((review) => (
        <Box
          key={review._id}
          p={2}
          mb={2}
          border="1px solid #ccc"
          borderRadius="6px"
        >
          <Typography variant="h6">
            {review.title}
          </Typography>

          <Typography variant="subtitle2">@{review.author.username || "Anonymous"}</Typography>
          <Typography variant="body1" mt={1}>
            {review.content}
          </Typography>
          {/* Upvote Button */}
            <Box mt={1}>
              <Button
                size="small"
                variant={review.voted ? "contained" : "outlined"}
                onClick={() => toggleVote(review._id)}
              >
                {review.voted ? "Unvote" : "Upvote"}
              </Button>
              <Typography variant="body2" component="span" ml={2}>
                {review.upvotes || 0} upvotes
              </Typography>
            </Box>
        </Box>
      ))}
    </Box>
  );
}

export default Page4SubPageA2;